import React from 'react';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';

type Props = {
    onClose: () => void;
};

const StyTitle = styled(Typography, {
    name: 'StyTitle',
})({
    display: 'inline',
});

const StyCloseIcon = styled(CloseIcon, {
    name: 'StyCloseIcon',
})({
    float: 'right',
    cursor: 'pointer',
});

const DashboardSendModalHeader = ({ onClose }: Props) => {
    const { t } = useTranslation();

    return (
        <Box>
            <StyTitle variant="h4">{t('sendDashboard.modalTitle')}</StyTitle>
            <StyCloseIcon onClick={onClose} fontSize="large" />
        </Box>
    );
};

export default DashboardSendModalHeader;
